
import $ from '../public/assets/js/jquery.min.js';

// TODO: NOT VERY GOOD SOLUTION
export function activate_header_menu() {
	$( document ).ready(() => {
		document.ActivateHeaderMenu();
	});

};



// WEBPACK FOOTER //
// ./src/utils.js